import { RouteRecordRaw } from 'vue-router'

import {
  brelagDeveloperRouteName,
  VIEW_ID,
} from '@/apps/brelag/brelag-developer/app'
import MainMenu from '@/apps/brelag/brelag-developer/components/MainMenu.vue'
import { clientAppRegistryGet } from '@/apps/clientAppRegistry'
import RouterPassThrough from '@/components/common/RouterPassThrough.vue'

const route: RouteRecordRaw = {
  path: clientAppRegistryGet(VIEW_ID, 'path'),
  name: VIEW_ID,
  redirect: { name: brelagDeveloperRouteName('equipment-group-root') },
  components: {
    default: RouterPassThrough,
    'main-menu': MainMenu,
  },
  children: [
    {
      path: 'equipment-group',
      name: brelagDeveloperRouteName('equipment-group-root'),
      redirect: { name: brelagDeveloperRouteName('equipment_group-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: brelagDeveloperRouteName('equipment_group-list'),
          props: true,
          component: () =>
            import(
              '../brelag-admin/components/equipment/EquipmentGroupList.vue'
            ),
        },
        {
          path: 'create',
          name: brelagDeveloperRouteName('equipment_group-create'),
          component: () =>
            import(
              '../brelag-admin/components/equipment/EquipmentGroupForm.vue'
            ),
          props: { id: '0' },
        },
        {
          path: ':id',
          name: brelagDeveloperRouteName('equipment_group-detail'),
          props: true,
          component: () =>
            import(
              '../brelag-admin/components/equipment/EquipmentGroupForm.vue'
            ),
        },
      ],
    },
    {
      path: 'equipment',
      name: brelagDeveloperRouteName('equipment-root'),
      redirect: { name: brelagDeveloperRouteName('equipment-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: brelagDeveloperRouteName('equipment-list'),
          props: true,
          component: () =>
            import('../brelag-admin/components/equipment/EquipmentList.vue'),
          meta: {
            requiresList: {
              equipment_group: true,
            },
            hasQuery: {
              equipment_group: true,
            },
          },
        },
        {
          path: 'create',
          name: brelagDeveloperRouteName('equipment-create'),
          component: () =>
            import('../brelag-admin/components/equipment/EquipmentForm.vue'),
          props: { id: '0' },
        },
        {
          path: ':id',
          name: brelagDeveloperRouteName('equipment-detail'),
          props: true,
          component: () =>
            import('../brelag-admin/components/equipment/EquipmentForm.vue'),
        },
        {
          path: 'instruction-step/create',
          name: brelagDeveloperRouteName('instructionstep-create'),
          props: { id: '0' },
          component: () =>
            import(
              '../brelag-admin/components/equipment/InstructionStepForm.vue'
            ),
        },
        {
          path: 'instruction-step/:id',
          name: brelagDeveloperRouteName('instructionstep-detail'),
          props: true,
          component: () =>
            import(
              '../brelag-admin/components/equipment/InstructionStepForm.vue'
            ),
        },
        {
          path: 'equipment-variant/create',
          name: brelagDeveloperRouteName('equipmentvariant-create'),
          props: { id: '0' },
          component: () =>
            import(
              '../brelag-admin/components/equipment/EquipmentVariantForm.vue'
            ),
        },
        {
          path: 'equipment-variant/:id',
          name: brelagDeveloperRouteName('equipmentvariant-detail'),
          props: true,
          component: () =>
            import(
              '../brelag-admin/components/equipment/EquipmentVariantForm.vue'
            ),
        },
      ],
    },
  ],
}

export default route
